function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import { Input, FormGroup, Label } from 'reactstrap';
import Collector from "../../../../services/collector";
import { useWorkFlow } from "../../../contexts/workflow";
import AsyncCreatableSelect from 'react-select/async-creatable';
import Translate from "../../../common/translation";
import Api, { ROUTES } from "../../../../services/api";
import { _Logger } from "../../../../services/core";
import { formatApiResponseToAddress } from "./address_utils";
import Icon from "../../../common/icon";

/**
 * Complex type
 * Search an address when typing inside the select.
 */
var Address = function Address(props) {
  var onChange = props.onChange,
    index = props.index,
    onUpdate = props.onUpdate,
    value = props.value;
  // HOOKS
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var currentOrder = collector.currentOrder,
    responses = collector.responses,
    diag = collector.diag,
    currentQuestion = collector.currentQuestion;
  // STATE
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedAsyncAddress = _useState2[0],
    setSelectedAsyncAddress = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    addressTimer = _useState4[0],
    setAddressTimer = _useState4[1];
  var mapReducer = function mapReducer(state, action) {
    switch (action.type) {
      case 'all':
        return action.value;
      case 'address':
      case 'postalCode':
      case 'city':
      case 'country':
      case 'region':
      case 'coordinate':
        var newState = _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.type, action.value));
        onChange(responses, newState, null, index);
        return newState;
      default:
        return state;
    }
  };
  var _useReducer = useReducer(mapReducer, {
      address: '',
      postalCode: '',
      city: '',
      country: ''
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    address = _useReducer2[0],
    dispatch = _useReducer2[1];

  /**
   * @param {string} terms
   */
  var getSuggestions = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(terms) {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Api.get("".concat(ROUTES.ADDRESS_EXIST, "/").concat(terms, "/").concat(diag.community.id || 0));
          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.data.map(function (item) {
              return {
                value: item,
                label: item.address
              };
            }));
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getSuggestions(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  /**
   * When typing on the react-select its start this function. careful need to return a resolving promise.
   *
   * @param {string} terms
   */
  var loadAsyncOptions = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(terms) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            clearTimeout(addressTimer);
            if (!(terms.length < 5)) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            return _context2.abrupt("return", new Promise(function (resolve) {
              var timeout = setTimeout(function () {
                resolve(getSuggestions(terms));
              }, 650);
              setAddressTimer(timeout);
            }));
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function loadAsyncOptions(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  /**
   * When clicking on the chosen address.
   *
   * @param {object} option
   */

  var onChangeAddress = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(option) {
      var selection, newAddress, selectedValue, _selectedValue, response, newState;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            selection = _objectSpread({}, option);
            newAddress = selection.label ? selection.label.split(',') : [];
            selection.label = newAddress.length > 0 ? newAddress[0] : '';
            selectedValue = selection.value;
            if (!(!selectedValue['center'] && !selectedValue['coordinate'])) {
              _context3.next = 15;
              break;
            }
            _context3.prev = 5;
            _context3.next = 8;
            return Api.post(ROUTES.GEOCODE, {
              place_id: selectedValue['place_id'],
              address: selectedValue['address'],
              communityId: diag.community.id
            });
          case 8:
            response = _context3.sent;
            selectedValue = _objectSpread(_objectSpread({}, response.data[0]), {}, {
              complete: (_selectedValue = selectedValue) === null || _selectedValue === void 0 ? void 0 : _selectedValue.complete
            });
            _context3.next = 15;
            break;
          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3["catch"](5);
            _Logger.error('Changement adresse ', 'ERROR', {
              e: _context3.t0
            });
          case 15:
            if (!(!selectedValue || !selectedValue.coordinate)) {
              _context3.next = 18;
              break;
            }
            _Logger.error('Changement adresse', 'FAILED', {
              selectedValue: selectedValue
            });
            return _context3.abrupt("return");
          case 18:
            // external influence
            if (onUpdate) {
              onUpdate(selectedValue);
            }
            newState = {
              address: selection.label,
              coordinate: selectedValue.coordinate,
              postalCode: selectedValue.postcode || selectedValue.postal_code || selectedValue.postalCode,
              city: selectedValue.city || selectedValue.locality,
              country: selectedValue.country,
              region: selectedValue.region,
              complete: selection.label
            };
            setSelectedAsyncAddress(selection);
            onChange(responses, newState, 'address', index);
            dispatch({
              type: 'all',
              value: newState
            });
          case 23:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[5, 12]]);
    }));
    return function onChangeAddress(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  var cleanAddress = function cleanAddress() {
    var defaultAddress = {
      address: '',
      postalCode: '',
      city: '',
      country: ''
    };
    setSelectedAsyncAddress(null);
    onChange(responses, defaultAddress, null, index);
    dispatch({
      type: 'all',
      value: _objectSpread({}, defaultAddress)
    });
  };

  /**
   * @param {object} value
   */
  var initializeValue = function initializeValue(value) {
    setSelectedAsyncAddress({
      value: {
        name: value['address'],
        coordinate: value['coordinate']
      },
      label: value['address']
    });
    dispatch({
      type: 'all',
      value: value
    });
  };
  function findResponsesByQuestionAlias(obj, targetAlias) {
    var results = [];
    function recursiveSearch(currentObj) {
      // Base case: if not an object or null, return
      if (_typeof(currentObj) !== 'object' || currentObj === null) return;
      for (var _i = 0, _Object$entries = Object.entries(currentObj); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          _value = _Object$entries$_i[1];
        if (key === 'questionAlias' && _value === targetAlias && currentObj.responses) {
          var _currentObj$loop;
          var result = {
            loop: (_currentObj$loop = currentObj.loop) === null || _currentObj$loop === void 0 || (_currentObj$loop = _currentObj$loop.match(/\d+/g)) === null || _currentObj$loop === void 0 ? void 0 : _currentObj$loop.join(''),
            response: currentObj.responses
          };
          results.push(result);
        }
        // Recursive case: if the current value is an object, search within it
        if (_typeof(_value) === 'object') {
          recursiveSearch(_value);
        }
      }
    }
    recursiveSearch(obj);
    return results;
  }

  /**
   * Initialization
   */
  useEffect(function () {
    var responsesFromHistoric = Collector.getCurrentOrderResponses(currentOrder, responses);
    var addressResponse = responsesFromHistoric ? responsesFromHistoric.responses : null;
    if (addressResponse) {
      addressResponse = formatApiResponseToAddress(addressResponse);
      initializeValue(addressResponse);
    } else {
      var matchedResponses = findResponsesByQuestionAlias(responses, currentQuestion.publicParameters['chargement']);
      var previousLoop = currentQuestion.loop_label - 1;
      if (matchedResponses && matchedResponses.length > 0 && currentQuestion.publicParameters['chargement']) {
        var _value2 = matchedResponses.find(function (response) {
          return response.loop === previousLoop.toString();
        }).response;
        if (_value2) {
          var newState = formatApiResponseToAddress(_value2, currentQuestion.publicParameters['chargement']);
          initializeValue(newState);
          onChange(responses, newState, 'address', index);
        }
      }
    }
  }, [currentOrder, responses]);

  /**
   * If address is used in another component that want to update its value.
   */
  useEffect(function () {
    if (!value) {
      return;
    }
    initializeValue(value);
  }, [value]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    className: "collectorMapLabel"
  }, /*#__PURE__*/React.createElement(Translate, {
    id: "collector_form_address_name"
  }), /*#__PURE__*/React.createElement(AsyncCreatableSelect, {
    cacheOptions: true,
    loadOptions: loadAsyncOptions,
    value: selectedAsyncAddress,
    onChange: onChangeAddress,
    className: "autocomplete-as-text",
    placeholder: /*#__PURE__*/React.createElement(Translate, {
      id: "collectorapp_address_road_zip_city"
    })
  }))), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    className: "collectorMapLabel"
  }, (address.postalCode || address.postCode) && /*#__PURE__*/React.createElement(Input, {
    type: "number",
    name: "postalCode",
    value: address.postalCode,
    onChange: function onChange(e) {
      return dispatch({
        type: 'postalCode',
        value: e.target.value
      });
    }
  }))), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    className: "collectorMapLabel"
  }, address.city && /*#__PURE__*/React.createElement(Input, {
    name: "city",
    value: address.city,
    onChange: function onChange(e) {
      return dispatch({
        type: 'city',
        value: e.target.value
      });
    }
  }))), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    className: "collectorMapLabel"
  }, address.region && /*#__PURE__*/React.createElement(Input, {
    name: "region",
    value: address.region,
    onChange: function onChange(e) {
      return dispatch({
        type: 'region',
        value: e.target.value
      });
    }
  }))), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    className: "collectorMapLabel"
  }, address.country && /*#__PURE__*/React.createElement(Input, {
    name: "country",
    value: address.country,
    onChange: function onChange(e) {
      return dispatch({
        type: 'country',
        value: e.target.value
      });
    }
  }))), address.address && /*#__PURE__*/React.createElement("a", {
    role: "button",
    onClick: cleanAddress,
    className: "clean-address"
  }, /*#__PURE__*/React.createElement(Translate, {
    id: "collector_clean_address"
  }), " ", /*#__PURE__*/React.createElement(Icon, {
    name: "broom"
  })));
};
Address.propTypes = {
  onChange: PropTypes.func.isRequired,
  onUpdate: PropTypes.func,
  elements: PropTypes.arrayOf(PropTypes.shape({})),
  bla: PropTypes.array,
  // Define bla as an array
  setBla: PropTypes.func // Define setBla as a function
};
Address.defaultProps = {
  elements: [],
  onUpdate: null,
  bla: [],
  // Provide a default value for bla as an empty array
  setBla: function setBla() {} // Provide a default value for setBla as an empty function
};
export default Address;